import React, {memo} from 'react';
import {Column} from '../Column';
import {Widget} from '../Widget';
import {Button} from '../Button';
import {InputModel, SensorTypeModel} from '../../types/control';
import {useSelector} from 'react-redux';

const getImage = (sensor: InputModel, type: SensorTypeModel) => {
    if (!type) {
        return null;
    }

    if (sensor.sensor_settings.value) {
        return type.image_set.active;
    }

    return type.image_set.passive;
};

export const Sensor = memo(
    function Sensor({sensor}: { sensor: InputModel }) {
        const type = useSelector(state => state.control.sensorTypeList.find(t => t.id === sensor.sensor_settings.sensor_type_id));
        return (
            <Column min={3} max={6}>
                <Widget style={{padding: 0}}>
                    <Button icon={getImage(sensor, type)} title={sensor.name} disabled={!sensor.is_active}/>
                </Widget>
            </Column>
        );
    },
);
